import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRouteV2 from 'commons-ui/src/permission/AuthorizedRoute';
import { ACTION, MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import KindRewardList from './submodules/list';

const KindRewards: React.FC<{}> = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<AuthorizedRouteV2
				configPageName={PAGE_NAMES.miscellaneous}
				configResourceName={MISCELLANEOUS_RESOURCES.kindRewards}
				configActionName={ACTION.fetchUserKindReward}
				path={`${path}/list`}
				component={KindRewardList}
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default KindRewards;
